//# sourceMappingURL=storage.mjs.map
/// <reference types="./storage.d.mts" />
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $dynamic from "../../gleam_stdlib/gleam/dynamic.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import { CustomType as $CustomType } from "../gleam.mjs";
import {
  length,
  key,
  getItem as get_item,
  getJson as get_json,
  removeItem as remove_item,
  setItem as set_item,
  clear,
} from "./storage.ffi.mjs";

export { clear, get_item, get_json, key, length, remove_item, set_item };

/**
 * References the [`sessionStorage`](https://developer.mozilla.org/docs/Web/API/Window/sessionStorage).
 */
export class Session extends $CustomType {}
export const Storage$Session = () => new Session();
export const Storage$isSession = (value) => value instanceof Session;

/**
 * References the [`localStorage`](https://developer.mozilla.org/docs/Web/API/Window/localStorage).
 */
export class Local extends $CustomType {}
export const Storage$Local = () => new Local();
export const Storage$isLocal = (value) => value instanceof Local;

export class QuotaExceededError extends $CustomType {}
export const StorageError$QuotaExceededError = () => new QuotaExceededError();
export const StorageError$isQuotaExceededError = (value) =>
  value instanceof QuotaExceededError;

export class MissingKeyError extends $CustomType {}
export const StorageError$MissingKeyError = () => new MissingKeyError();
export const StorageError$isMissingKeyError = (value) =>
  value instanceof MissingKeyError;

export class InvalidJsonError extends $CustomType {}
export const StorageError$InvalidJsonError = () => new InvalidJsonError();
export const StorageError$isInvalidJsonError = (value) =>
  value instanceof InvalidJsonError;

/**
 * Write an arbitrary data to `Storage`. Data should be a valid JSON
 * to save structured data. The operation can fail if the local storage quota
 * is exceeded.
 *
 * Look `storage.set_item` to set any arbitrary item.
 *
 * ```gleam
 * json.object([
 *   #("first_field", json.string("first_value")),
 *   #("second_field", json.int(2)),
 *   #("third_field", json.bool(True)),
 * ])
 * |> storage.set_json(storage.Local, "example", _)
 * ```
 */
export function set_json(storage, key, content) {
  let _pipe = $json.to_string(content);
  let _pipe$1 = ((_capture) => { return set_item(storage, key, _capture); })(
    _pipe,
  );
  return $result.replace(_pipe$1, undefined);
}
